<template>
  <div class="resident-data">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container-fluid">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div
            class="
              col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12
              d-flex
              align-items-center
              space-reuturn
            "
            v-if="width > 959"
          >
            <v-btn class="btn-return ml-5" v-on:click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
            </v-btn>
          </div>
          <div
            class="
              col-xl-10 col-lg-10 col-md-9 col-sm-11 col-12
              d-flex
              align-items-center
            "
          >
            <div class="row">
              <div
                class="
                  p-0
                  col-xl-1 col-lg-1 col-md-2 col-sm-2 col-12
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <img
                  v-if="resident.photo_url"
                  :src="resident.photo_url"
                  class="photo-url"
                />
                <img
                  v-if="!resident.photo_url"
                  class="photo-url"
                  :src="require('../../assets/user.png')"
                />
              </div>
              <div
                class="
                  col-xl-11 col-lg-11 col-md-10 col-sm-10 col-12
                  d-flex
                  align-items-center
                "
              >
                <h4 class="m-0 title-pages center-text">
                  {{ resident.name }}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- v-if="width > 959" -->
          <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12 pl-0">
            <!-- <div class="d-flex align-items-center">
              <button
                v-if="permission('read', 'resident_information')"
                @click="handleStep('informations')"
                :outlined="step != 'informations'"
                :class="[
                  step == 'informations' && 'btn-nav-menu',
                  step != 'informations' && 'btn-nav-menu1',
                ]"
              >
                INFORMAÇÕES
              </button>
              <div
                :class="[
                  step == 'informations' && 'triangulo-para-direita',
                  step != 'informations' && 'triangulo-none',
                ]"
              ></div>
            </div> -->
            <div class="d-flex align-items-center">
              <button
                v-if="permission('read', 'evolution_speech_therapist')"
                @click="handleStep('checking-account')"
                :outlined="step != 'checking-account'"
                :class="[
                  step == 'checking-account' && 'btn-nav-menu',
                  step != 'checking-account' && 'btn-nav-menu1',
                ]"
              >
                CONTA CORRENTE
              </button>
              <div
                :class="[
                  step == 'checking-account' && 'triangulo-para-direita',
                  step != 'checking-account' && 'triangulo-none',
                ]"
              ></div>
            </div>
          </div>
          <div
            class="col-xl-10 col-lg-10 col-md-9 col-sm-12 col-12 pt-0 pl-0 pr-0"
          >
            <div
              v-if="step == 'informations'"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            >
              <Information />
            </div>
            <div
              v-if="step == 'checking-account'"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            >
              <CheckingAccount />
            </div>
          </div>
        </div>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import api from "../../services/api";

import Information from "./Resident/Information";

import CheckingAccount from "./Resident/CheckingAccount";

import routes from "../../routes";

import { formatDate, formatDateToUs } from "../../lib/format";

import permission from "../../lib/permission";

import ErrorsMessages from "../Components/ErrorsMessages";

export default {
  name: "FamilyResident",
  components: {
    NavBar,
    AuthBySessionExpired,
    Information,
    CheckingAccount,
    ErrorsMessages,
  },
  data() {
    return {
      step: "checking-account",
      resident_id: null,
      resident: {
        name: null,
        photo_url: null,
      },
      loading: true,
      width: window.screen.width,
      errors: [],
    };
  },
  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  methods: {
    permission,
    formatDate,
    formatDateToUs,
    handleStep(step) {
      let newTab = {
        informations: "informations",
        "checking-account": "checking-account",
      }[step];

      let { tab } = routes.history.current.query;

      if (tab != newTab) {
        routes.replace({ query: { tab: newTab } });
      }

      this.step = step;
    },
    handleOnResize() {
      this.width = window.innerWidth;
    },
    async retrieve() {
      const { id } = routes.history.current.params;

      const { tab } = routes.history.current.query;

      if (tab) {
        this.step = {
          informations: "informations",
          "checking-account": "checking-account",
        }[tab];
      }

      this.resident_id = id;

      if (this.errors.length == 0) await this.get();
    },
    async get() {
      try {
        this.loading = true;

        const { resident_id: id } = this;

        let params = { id };

        const response = await api.get("/rest-home/resident/name", {
          params,
        });

        const { resident, error } = response.data;

        if (error) {
          return routes.push({ name: "dashboard" });
        }

        if (!resident) {
          return routes.push({ name: "dashboard" });
        }

        this.resident = resident;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToBack() {
      if (!routes.go(-1)) {
        routes.push({ name: "dashboard" });
      } else {
        routes.go(-1);
      }
    },
  },
};
</script>
